import { PackageEnum } from '@insurance/api/requests'
import { BooleanRadioCardGroup } from '@insurance/components'
import { Form } from 'antd'
import { useTranslation } from 'react-i18next'

import { useCascoInsuranceValues } from './CascoInsuranceContext'
import { formProps } from './utils'

export const FiftyFiftyFull = () => {
  const { t } = useTranslation()
  const { fiftyFiftyFullProps, insurancePackageProps } = formProps(t)
  const { isEditable, order } = useCascoInsuranceValues()

  const insurancePackage = Form.useWatch<PackageEnum>(
    insurancePackageProps.name,
    { preserve: true }
  )

  if (insurancePackage !== PackageEnum.FIFTY_FIFTY || !isEditable) return null

  return (
    <Form.Item {...fiftyFiftyFullProps}>
      <BooleanRadioCardGroup
        defaultValue={false}
        disabled={order?.casco?.casco?.fifty_fifty_full}
      />
    </Form.Item>
  )
}
